const map = require('lodash/fp/map');
const dateFormat = require('date-fns/format');
const memoizer = require('../request-handler/utils/memoizer');



function parseJson(result) {
  // debugger;
  return JSON.stringify(result);
}

function parseHistoryJson(result) {
  // debugger;

  const history = result.discoveryStatus;
  return JSON.stringify(history);
}


function serviceFactory({ api }) {
  const getDiscoveryHistory = memoizer()(({ metaData }) =>
    api.getDiscoveryHistory(metaData)
      .then(parseHistoryJson));

    const addDiscoveryHistory = memoizer()(({ discoItem, metaData }) =>
      api.addDiscoveryHistory(discoItem, metaData)
        .then(parseJson));
    
  
      return {
    getDiscoveryHistory,
    addDiscoveryHistory
  };
}

module.exports = serviceFactory;


